import React from 'react';
import './homes.css';


export default function home() {
  return (
    <section id='home'>
      <div className="body">
        <div className="header_t">
          <h1 className='h_txt'> Welcome To EcoFestEssentials</h1>
          <h2 className='h_txt2'>"Savor the moment, Preserve the planet"</h2>
          <h3 className='h_txt3'>"An sustainable and eco-friendly dining solutions for conscious consumers."</h3>
        </div>
      </div>
    </section>
  )
}
